import React, { Component } from "react";
import { Loader } from "../Common/Loader";
import { formatTime, getTimeParts } from "../../utils";

class VideoPlayer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            poster: this.props.poster,
            source: this.props.source,
            play: false,
            videoId: this.props.videoId,
            clickedVideoDetail: [],
            rotatingGlobeStyle: {
                display: 'inline-block'
            },
            neonGlobeStyle: {
                display: 'none'
            },
            videoProgress: 0,
            totalVideoDuration: "00:00:00",
            videoTimeElapsed: "00:00:00",
            videoPlayed: this.props.autoPlay || false,
            videoPaused: true,
            fadeOutRatio: 1.0,
            seconds: 0
        };

        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseUp = this.handleMouseUp.bind(this);
        this.playVideo = this.playVideo.bind(this);
        this.pauseVideo = this.pauseVideo.bind(this);
        this.fastForward = this.fastForward.bind(this);
        this.fastBackward = this.fastBackward.bind(this);
        //this.skipVideo = this.skipVideo.bind(this);
    }

    componentDidMount() {
        if (this.state.source != undefined && this.state.source != '') {
            //this.playVideo();
        }
    }

    /**
     * Calculate video time
     */
    calculateVideoTime() {
        this.setState(prevState => ({
            clickedVideoDetail: [...prevState.clickedVideoDetail, Math.ceil((this.refs.video.currentTime * 1000) - 1000)]
        }))
    }

    /**
     * get the status of video
    */
    endVideo() {
        let videoElem = this.refs.video;
        let videoElemDuration = videoElem.duration;
        let videoElemCurrentTime = videoElem.currentTime;

        this.updateVideoProgress(videoElemDuration, videoElemCurrentTime);

        if (videoElem.ended) {
            if (this.props.getclickCount != undefined) {
                //Call the funtion if exist in parent component
                this.props.getclickCount(this.state.clickedVideoDetail, this.props.videoId);
            } else {
                // window.location.assign('/home');
            }

            this.setState({
                videoPaused: true
            })
        }
    }

    /**
     * mouse down event
     */
    handleMouseDown() {
        this.updateGlobeStyle('none', 'inline-block');
    }

    /**
     * mouse up event
     */
    handleMouseUp() {
        setTimeout(() => {
            this.updateGlobeStyle('inline-block', 'none');
        }, 200);
    }

    /**
     * Update globe style
     * @param rGlobeStyle
     * @param nGlobeStyle
     */
    updateGlobeStyle(rGlobeStyle, nGlobeStyle) {
        this.setState({
            rotatingGlobeStyle: {
                display: rGlobeStyle
            },
            neonGlobeStyle: {
                display: nGlobeStyle
            }
        });
    }

    skipVideo = (e) => {
        //e.preventDefault();
        this.props.gotoWebApp(e)

    }

    /**
     * Update progress bar
     * @param progress
     */
    updateVideoProgress(videoElemDuration, videoElemCurrentTime) {
        const progress = (videoElemCurrentTime * 100) / videoElemDuration;
        const totalDuration = formatTime(videoElemDuration);
        const timeElapsed = formatTime(videoElemCurrentTime);

        if (this.props.onlyPlayer) {
            const seconds = getTimeParts(videoElemCurrentTime)[2];
            const fadeOutValue = this.state.fadeOutRatio - 0.05;
            if (seconds >= 4) {
                this.setState({
                    fadeOutRatio: fadeOutValue,
                    seconds
                }, () => { this.props.onFadeOutVideo && this.props.onFadeOutVideo(this.state.fadeOutRatio, this.state.seconds) })
            }
        }

        this.setState({
            videoProgress: progress,
            totalVideoDuration: totalDuration,
            videoTimeElapsed: timeElapsed
        })
    }

    /**
     * Play video
     */
    playVideo() {
        this.refs.video.play();
        this.setState({
            videoPlayed: true,
            videoPaused: false,
        });
    }

    /**
     * Pause video
     */
    pauseVideo() {
        this.refs.video.pause();
        this.setState({
            videoPaused: true
        });
    }

    /**
     * Fast forward video by {seconds} seconds
     */
    fastForward(seconds = 10) {
        const video = this.refs.video;
        const duration = video.duration;
        const currentTime = video.currentTime;
        let newTime = currentTime + seconds;

        if (duration < newTime) {
            newTime = duration;
        }

        video.currentTime = newTime;

        this.setState({
            seconds: newTime
        });
    }

    /**
     * Fast backward video by {seconds} seconds
     */
    fastBackward(seconds = 10) {
        const video = this.refs.video;
        const currentTime = video.currentTime;
        let newTime = currentTime - seconds;

        if (newTime < 0) {
            newTime = 0;
        }

        video.currentTime = newTime;

        this.setState({
            seconds: newTime
        });
    }

    videoPlayerHtml() {
        const videoDetail = this.props;

        const contextMenu = function (e) {
            e.preventDefault();
            return false;
        }

        const mouseDownOnPlayer = () => {
            this.calculateVideoTime(videoDetail.videoId);
            this.handleMouseDown();
        };

        let playPauseHandler = null;
        let playPauseButtonClass = 'fa fa-';

        if (this.state.videoPaused) {
            playPauseButtonClass += 'play';
            playPauseHandler = this.playVideo;
        } else {
            playPauseButtonClass += 'pause';
            playPauseHandler = this.pauseVideo;
        }

        return (
            <div className="video-player">
                {
                    !this.state.videoPlayed && (
                        <a
                            href="javascript:void(0)"
                            className="play-btn"
                            onClick={() => this.playVideo()}
                        >
                            <i className="fa fa-play-circle"></i>
                        </a>
                    )
                }
                <video
                    onContextMenu={contextMenu}
                    width={videoDetail.width || '100%'}
                    height={videoDetail.height || '100%'}
                    id="video"
                    ref="video"
                    autoPlay={videoDetail.autoPlay || false}
                    muted={videoDetail.muted || false}
                    poster={videoDetail.poster}
                    onMouseDown={mouseDownOnPlayer}
                    onMouseUp={this.handleMouseUp}
                    onTimeUpdate={this.endVideo.bind(this)}
                >
                    <source src={`${videoDetail.source}`} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                {
                    !this.props.onlyPlayer && (
                        <div className="video-play pause" onClick={() => this.calculateVideoTime(videoDetail.videoId)}>
                            <img id="rotating_globe" width="100" style={this.state.rotatingGlobeStyle} onMouseDown={this.handleMouseDown} onMouseUp={this.handleMouseUp} src="/assets/images/eathdeck/1Earth-revolving-256-slow-new.gif" />
                            <img id="neon_globe" style={this.state.neonGlobeStyle} width="100" onMouseUp={this.handleMouseUp} src="/assets/images/eathdeck/neon-globe-transparent-color.png" />
                        </div>
                    )
                }

                {
                    !this.props.onlyPlayer ?
                        ''/*<a href={`/${this.props.skipTo}`} className="skip-button"><img src="assets/images/eathdeck/skip-arrow.png" /></a>*/
                        :
                        !this.props.hideSkipArrow && <a onClick={this.skipVideo} className="skip-button"><img src="assets/images/eathdeck/skip-arrow.png" /></a>
                } 
                <div className="video-progress" style={{...this.props.videoStyle}}>
                    {(!this.props.onlyPlayer || this.props.showControls) && <div className="control-row">
                        <div className="control" onClick={() => this.fastBackward()}>
                            <i className="control-icon fa fa-fast-backward"></i>
                        </div>
                        <div className="control" onClick={() => playPauseHandler()}>
                            <i className={`control-icon ${playPauseButtonClass}`}></i>
                        </div>
                        <div className="control" onClick={() => this.fastForward()}>
                            <i className="control-icon fa fa-fast-forward"></i>
                        </div>
                    </div>}
                    <div className='video-progress-container'>
                        <div className="video-progress-bar" style={{ width: `${this.state.videoProgress}%` }}></div>
                    </div>
                </div>
                <div className="video-duration" style={{...this.props.videoStyle}}>{this.state.videoTimeElapsed}/{this.state.totalVideoDuration}</div>
            </div>
        );
    }

    /**
     * Render video
     * @returns {*}
     */
    render() {
        if (this.props.fullScreen == undefined) {
            return (
                <div className="row">
                    <div className="medium-12 columns">
                        {this.videoPlayerHtml()}
                    </div>
                </div>
            );
        } else {
            return (
                <div>
                    {this.videoPlayerHtml()}
                </div>
            );
        }
    }
}

export default VideoPlayer;



// WEBPACK FOOTER //
// ./components/Common/VideoPlayer.js